const mobileViewport = window.matchMedia('(max-width: 749px)');
const sections = new WeakMap();

/** @param {ParentNode} [root] */
export function positionResponsiveGalleries(root = document) {
    for (const gallery of root.querySelectorAll('media-gallery[data-na-responsive-gallery]')) {
        const section = gallery.closest('.shopify-section');
        const mobileSlot = section?.querySelector('[data-na-gallery-mobile]');
        if (!(section instanceof HTMLElement) || !(mobileSlot instanceof HTMLElement)) continue;
        const existing = sections.get(section);
        if (existing) {
            existing();
            continue;
        }
        const desktopSlot = gallery.parentElement;
        if (!desktopSlot) continue;
        const desktopStyle = gallery.getAttribute('style') || '';
        const desktopFit = gallery.getAttribute('data-media-fit') || 'contain';
        const desktopSticky = gallery.classList.contains('sticky-content');
        const desktopControls = gallery.querySelector('slideshow-controls');
        const desktopThumbnailRadius =
            desktopControls instanceof HTMLElement
                ? desktopControls.style.getPropertyValue('--thumbnail-radius')
                : '0px';
        let currentGallery = gallery;
        if (!customElements.get('slideshow-component')) {
            gallery.querySelector('slideshow-slide:not([hidden])')?.setAttribute('aria-hidden', 'false');
        }

        const position = () => {
            if (!section.isConnected) {
                mobileViewport.removeEventListener('change', position);
                return;
            }
            const mobile = mobileViewport.matches;
            const destination = mobile ? mobileSlot : desktopSlot;
            if (currentGallery.parentElement !== destination) {
                if ('moveBefore' in destination && typeof destination.moveBefore === 'function') {
                    destination.moveBefore(currentGallery, null);
                } else {
                    const replacement = currentGallery.cloneNode(true);
                    if (!(replacement instanceof HTMLElement)) return;
                    currentGallery.remove();
                    destination.append(replacement);
                    currentGallery = replacement;
                }
            }
            const fit = mobile ? mobileSlot.dataset.mediaFit || desktopFit : desktopFit;
            currentGallery.classList.toggle('mobile:hidden', !mobile);
            currentGallery.classList.toggle(
                'sticky-content',
                mobile ? mobileSlot.dataset.mediaSticky === 'true' : desktopSticky
            );
            currentGallery.setAttribute('style', mobile ? mobileSlot.getAttribute('style') || '' : desktopStyle);
            currentGallery.setAttribute('data-media-fit', fit);
            for (const slide of currentGallery.querySelectorAll('slideshow-slide')) {
                if (slide instanceof HTMLElement) slide.style.setProperty('--product-media-fit', fit);
            }
            for (const controls of currentGallery.querySelectorAll('slideshow-controls')) {
                if (!(controls instanceof HTMLElement)) continue;
                controls.style.setProperty(
                    '--thumbnail-radius',
                    mobile ? `${mobileSlot.dataset.thumbnailRadius}px` : desktopThumbnailRadius
                );
            }
        };
        sections.set(section, position);
        position();
        mobileViewport.addEventListener('change', position);
    }
}

document.addEventListener('shopify:section:load', () => positionResponsiveGalleries());

if (document.readyState === 'loading') {
    document.addEventListener('readystatechange', () => positionResponsiveGalleries(), { once: true });
} else {
    positionResponsiveGalleries();
}
